import { RG_TYPE } from '../../types/rg-type.js';
import { ApartmentLikeTypes } from './apartment-like-types.js';
import { ModuleLikeTypes } from './module-like-types.js';

/** Dictionary of children and their allowed parent type */
const RgParent = {
    [RG_TYPE.World]: [],
    [RG_TYPE.Site]: [RG_TYPE.World],
    [RG_TYPE.Zone]: [RG_TYPE.Site],
    [RG_TYPE.Plot]: [RG_TYPE.Zone],
    [RG_TYPE.Building]: [RG_TYPE.Plot],
    [RG_TYPE.Core]: [RG_TYPE.Building],
    [RG_TYPE.Entrance]: [RG_TYPE.Building],
    [RG_TYPE.Corridor]: [RG_TYPE.Building],
    [RG_TYPE.TechnicalSpace]: [RG_TYPE.Building],
    [RG_TYPE.TechnicalSpaceRoom]: [RG_TYPE.TechnicalSpace],
    [RG_TYPE.Apartment]: [RG_TYPE.Building],
    [RG_TYPE.Module]: ApartmentLikeTypes,
    [RG_TYPE.Balcony]: [RG_TYPE.Apartment],
    [RG_TYPE.Roof]: [RG_TYPE.Building],
    [RG_TYPE.Ceiling]: ModuleLikeTypes,
    [RG_TYPE.Floor]: ModuleLikeTypes,
    [RG_TYPE.Wall]: ModuleLikeTypes,
    [RG_TYPE.Facade]: [RG_TYPE.Building],
    [RG_TYPE.Beam]: ModuleLikeTypes,
    [RG_TYPE.Door]: [RG_TYPE.Wall],
    [RG_TYPE.Window]: [RG_TYPE.Wall],
    [RG_TYPE.Opening]: [RG_TYPE.Wall, RG_TYPE.Facade],
    [RG_TYPE.Column]: ModuleLikeTypes,
    [RG_TYPE.Room]: [RG_TYPE.Apartment],
    [RG_TYPE.Parapet]: [RG_TYPE.Building],
    [RG_TYPE.EmptySpace]: [RG_TYPE.Building],
    [RG_TYPE.Glazing]: [RG_TYPE.Facade]
};

export { RgParent };
//# sourceMappingURL=rg-parent.js.map
